import { FileMappingRow, SalesforceUniqueFieldTarget } from '@r1-compass-library/models';

export type PlayFileImport = {
    fileName: string | undefined;
    headers: string[];
    customFileMapping: FileMappingRow[];

    /**
     * @Deprecated and will be removed in a future release
     */
    salesforceUniqueFieldTarget?: SalesforceUniqueFieldTarget;
    salesforceUniqueFieldSourceName: string;
    /**
     * @deprecated Do not save anymore
     */
    salesforceUniqueRecommendationFieldTargetName?: string;
};

/**
 * @description This value does not matter because storying the value here for this required row
 * was deprecated once we moved the value to the division config
 * @see {@link https://relationshipone.atlassian.net/browse/CLOUD-10671}
 * @see {@link https://github.com/relationshipone/r1-tfs-compass-ui/pull/391}
 */
export const deprecatedsalesforceUniqueRecommendationFieldTargetNamePlaceholderValue = 'mock' as const;
